import { ref } from '@nuxtjs/composition-api';
import { STEP_TYPE } from '~/constants/StepType';
import useSubscriptions from '~/composable/checkout/validations/useSubscriptions'
import { VALIDATION_STATUS } from '~/constants/ValidationStatus';
import useCheckoutInfo from '~/composable/useCheckoutInfo';
import useTlmCart from '~/composable/useTlmCart';
import { CUSTOMER_SUBSCRIPTION_TYPE } from '~/constants/CheckoutFlow'
import useCustomer from '~/composable/customer/useCustomer';
import useMitID from '~/composable/useMitID';

const appContext = ref(null)
export default function deviceAndSubscriptionFlowHandler () {
  const validValidationPromise = () => {
    return Promise.resolve({
      actionStatus: VALIDATION_STATUS.VALID,
      signupBlockingNotifications: [],
      hasSignupBlockingNotification: false
    });
  }
  const initialize = (app) => {
    return new Promise(() => {
      appContext.value = app;
    });
  }

  const preValidate = () => {
    const { preValidateSubscriptions } = useSubscriptions(appContext.value)
    return preValidateSubscriptions();
  }

  const validate = (subscriptionSignUpDataNew) => {
    const { validateSubscriptions } = useSubscriptions(appContext.value)
    return validateSubscriptions(subscriptionSignUpDataNew);
  }

  const execute = () => {
    return validValidationPromise()
  }

  const finalize = () => {
    return validValidationPromise()
  }

  // eslint-disable-next-line complexity
  const finalizeStep = async (stepType, state, appContext) => {
    const customerInfo = state.customerInfo
    const subscription = state.subscription
    const numberInfo = state.numberInfo
    const { addAddressInformation } = useCustomer(appContext)
    const { getCartID, isProtectedAddress } = useTlmCart(appContext)
    const { getMitIdToken } = useMitID(appContext)
    const {
      addPrepaidEmail,
      addNumberInfo,
      addPermissionInformation,
      removeChangeSubscriptionCustomerInfo,
      removeNumberInfo,
      addChangeSubscriptionCustomerInfo
    } = useCheckoutInfo(appContext)
    switch (stepType) {
      case STEP_TYPE.SUBSCRIPTION_TYPE:
        if (subscription.menu.value === CUSTOMER_SUBSCRIPTION_TYPE.CHANGE_SUBSCRIPTION) {
          await removeNumberInfo()
          await addChangeSubscriptionCustomerInfo(subscription.changeSubscription.prepaidAccountId, subscription.changeSubscription.serviceAccountId)
          break
        }
        if (subscription.menu.value !== CUSTOMER_SUBSCRIPTION_TYPE.KEEP_SUBSCRIPTION) {
          await removeChangeSubscriptionCustomerInfo()
          await addNumberInfo(numberInfo.value)
        }
        break;
      case STEP_TYPE.CUSTOMER_INFO_CONFIRMATION:
        if (isProtectedAddress.value) {
          await addAddressInformation({
            useBillingAddressAsShipping: true,
            shippingAddress: customerInfo.customerDetails.value.addressDTO,
            billingAddress: customerInfo.customerDetails.value.addressDTO,
            emailAddress: customerInfo.customerDetails.value.email,
            cartID: getCartID.value,
            tempAddressIdentifier: getMitIdToken()
          });
        }
        await addPermissionInformation({
          permissionEmail: customerInfo.permissionsAccepted.value,
          permissionSms: customerInfo.permissionsAccepted.value,
          permissionCall: customerInfo.permissionsAccepted.value,
          permissionTermsText: customerInfo.permissionText + customerInfo.linkText
        })
        await addPrepaidEmail(customerInfo.customerDetails.value.email)
        break;
      default:
        return true;
    }
  }

  return {
    initialize,
    preValidate,
    validate,
    execute,
    finalize,
    finalizeStep
  }
}
